import { useEffect, useState } from 'react'
import Axios from 'axios'
import { DistrictFilter } from '../dto/gateway.dto'

export const useDistricts = () => {
    const [districts, setDistricts] = useState<DistrictFilter[]>([])
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        setLoading(true)
        Axios.get('/gateways/districts')
            .then((res) => {
                const records: DistrictFilter[] = []
                const exist: Record<string, boolean> = {}
                res.data.forEach((row: string, index: number) => {
                    records.push({
                        text: row,
                        value: row,
                    })
                    exist[row] = true
                })

                setDistricts(records)
            })
            .catch((err) => {
                console.error(err)
            })
            .finally(() => {
                setLoading(false)
            })
    }, [])

    return { districts, loading }
}
